import React, { Component } from "react";
import { observer } from "mobx-react";

import { Uuid } from "@formant/core/model/Uuid";

import { IPopupProps, Popup } from "../../common/Popup";
import * as styles from "./index.scss";

export interface IAudioVideoSetupPopup extends IPopupProps {
    id: Uuid;
}

@observer
export class AudioVideoSetupPopup extends Component<IAudioVideoSetupPopup> {
    render() {
        const { visible, onClose } = this.props;
        return (
            <Popup
                visible={visible}
                onClose={onClose}
                windowClassName={styles["video-setup-window"]}
            >
                Audio & Video Settings
            </Popup>
        );
    }
}
